import { render } from "./UserAuthentication.vue?vue&type=template&id=1b4ae979&scoped=true"
import script from "./UserAuthentication.vue?vue&type=script&lang=js"
export * from "./UserAuthentication.vue?vue&type=script&lang=js"

import "./UserAuthentication.vue?vue&type=style&index=0&id=1b4ae979&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4ae979"]])

export default __exports__